import { useNavigate } from 'react-router-dom'

const styles = `
body{
    margin:0;
    font-family:'Open Sans',sans-serif;
    background:#f7f8fc;
}

.destination-hero{
    background:#1a2e6e;
    color:white;
    padding:80px 20px;
}

.destination-container{
    max-width:1100px;
    margin:auto;
}

.destination-hero h1{
    font-size:46px;
    margin-bottom:15px;
    font-family:'Nunito',sans-serif;
}

.destination-hero p{
    font-size:18px;
    max-width:700px;
    opacity:.9;
    line-height:1.7;
}

.destination-content{
    max-width:1000px;
    margin:50px auto;
    background:white;
    border-radius:16px;
    padding:45px;
    box-shadow:0 10px 30px rgba(0,0,0,.08);
}

.destination-content h2{
    color:#1a2e6e;
    margin-top:40px;
    margin-bottom:20px;
    font-size:30px;
}

.destination-content h3{
    color:#1a2e6e;
    margin:30px 0 15px;
}

.destination-content p{
    line-height:1.9;
    color:#555;
}

.destination-content li{
    margin-bottom:15px;
    line-height:1.8;
}

.highlight{
    background:#eef8f2;
    border-left:6px solid #39b36a;
    padding:25px;
    border-radius:12px;
    margin-top:35px;
}

.process{
    background:#f5f7fb;
    padding:22px;
    border-radius:12px;
    text-align:center;
    font-weight:bold;
    margin:25px 0;
    color:#1a2e6e;
}

.back-btn{
    margin-bottom:30px;
    background:#f5a623;
    color:white;
    border:none;
    padding:12px 24px;
    border-radius:8px;
    cursor:pointer;
    font-weight:bold;
}

.back-btn:hover{
    opacity:.9;
}

@media(max-width:768px){

.destination-hero h1{
    font-size:34px;
}

.destination-content{
    margin:20px;
    padding:25px;
}

}
`

export default function MalaysiaDestination() {
  const navigate = useNavigate()

  return (
    <>
      <style>{styles}</style>

      <section className="destination-hero">
        <div className="destination-container">
          <button className="back-btn" onClick={() => navigate('/', { state: { scrollTo: 'study-destinations' } })}>
            ← Back
          </button>

          <h1>🇲🇾 Malaysia</h1>

          <p>Affordable world-class education, internationally recognised degrees, English-medium programs and one of the safest study destinations in Asia.</p>
        </div>
      </section>

      <div className="destination-content">
        <h2>Why Choose Malaysia?</h2>

        <ul>
          <li>
            <b>World-Class Degrees</b> — Study UK, Australian and US university programs at a much lower cost.
          </li>

          <li>
            <b>100% English Programs</b> — Most universities teach completely in English.
          </li>

          <li>
            <b>High Visa Success</b> — Malaysia has a streamlined EMGS student visa process.
          </li>

          <li>
            <b>Affordable Living</b> — Tuition fees and living costs are among the lowest in Asia.
          </li>

          <li>
            <b>Safe & Multicultural</b> — A welcoming environment with students from around the world.
          </li>
        </ul>

        <h2>Required Documents</h2>

        <ul>
          <li>Passport (minimum 18 months validity)</li>

          <li>SSC / HSC / Bachelor's Certificates & Transcripts</li>

          <li>Passport Size Photograph</li>

          <li>Statement of Purpose (SOP)</li>

          <li>IELTS / TOEFL (if required)</li>

          <li>Bank Solvency Statement</li>
        </ul>

        <h2>Application Process</h2>

        <div className="process">Profile Evaluation → Offer Letter → EMGS eVAL → Single Entry Visa → Fly to Malaysia 🎉</div>

        <ol>
          <li>Select your preferred university and course.</li>

          <li>Receive your Offer Letter.</li>

          <li>Apply for EMGS eVAL.</li>

          <li>Apply for your Student Visa.</li>

          <li>Book your flight.</li>

          <li>Complete registration after arrival.</li>
        </ol>

        <div className="highlight">
          <h3>🤝 How StudyBuddy Helps</h3>

          <ul>
            <li>University selection based on your profile.</li>

            <li>Application submission.</li>

            <li>Document verification.</li>

            <li>Visa processing support.</li>

            <li>Bank solvency guidance.</li>

            <li>Accommodation assistance.</li>

            <li>Pre-departure briefing.</li>

            <li>Post-arrival support.</li>
          </ul>
        </div>
      </div>
    </>
  )
}
